import React from "react";
import { Controller, Control, FieldErrors, FieldValues } from "react-hook-form";
import { FormControlLabel, Checkbox, Typography } from "@mui/material";

interface ReimbursementConfirmationProps<T extends FieldValues> {
  control: Control<T>;
  errors: FieldErrors<T>;
  hasBankAccount: boolean;
}

const ReimbursementConfirmation: React.FC<ReimbursementConfirmationProps<any>> = ({ control, errors, hasBankAccount }) => (
  <>
    <Controller
      name="confirmation"
      control={control}
      rules={{ required: "Please confirm the information is true and correct" }}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} data-testid="confirmation-checkbox" />}
          label="I confirm that the information I have provided is true and correct and that the uploaded attachments include the policy holder name, dates of coverage, and a verification of payment/receipt that displays the amount paid."
        />
      )}
    />
    {errors.confirmation && (
      <Typography data-testid="confirmationError" variant="body2" color="error">
        {typeof errors.confirmation.message === "string" ? errors.confirmation.message : ""}
      </Typography>
    )}

    {!hasBankAccount && (
      <>
        <Controller
          name="understanding"
          control={control}
          rules={{ required: "Please acknowledge the bank account requirement" }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} checked={field.value} data-testid="understanding-checkbox" />}
              label="I understand that if I do not add a bank account to My Account, When will mail a check to the address on record."
            />
          )}
        />
        {errors.understanding && (
          <Typography data-testid="bankAccountCheckboxError" variant="body2" color="error">
            {typeof errors.understanding.message === "string" ? errors.understanding.message : ""}
          </Typography>
        )}
      </>
    )}

    <Controller
      name="attestation"
      control={control}
      rules={{ required: "Please attest to your When Benefit eligibility" }}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} data-testid="attestation-checkbox" />}
          label="I attest that I am not enrolled in any other insurance coverage, which would violate the terms of my When Benefit eligibility as defined in my separation agreement (if applicable)."
        />
      )}
    />
    {errors.attestation && (
      <Typography data-testid="attestationError" variant="body2" color="error">
        {typeof errors.attestation.message === "string" ? errors.attestation.message : ""}
      </Typography>
    )}
  </>
);

export default ReimbursementConfirmation;
